import { useEffect, useState } from 'react';
import { brandOverride } from '../../clients/brandOverride';

export const useChallengeStartTime = () => {
  const challengeStartDate = new Date(brandOverride().challengeStartDate);
  challengeStartDate.setHours(9, 0, 0);
  const startTimeTzOffset = challengeStartDate.getTimezoneOffset() * 60000;
  const todayTzOffset = new Date(Date.now()).getTimezoneOffset() * 60000;
  const tzOffset = startTimeTzOffset + todayTzOffset;
  const challengeStartTime = challengeStartDate.getTime() + tzOffset;
  const [isSignUpPeriod, setIsSignUpPeriod] = useState(false);

  useEffect(() => {
    if (challengeStartTime > Date.now()) {
      setIsSignUpPeriod(true);
    }
  }, [challengeStartTime]);

  return {
    challengeStartTime,
    isSignUpPeriod,
    setIsSignUpPeriod,
  };
};
